import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Grid, Button, IconButton, Fade } from '@mui/material';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ContainerPainel from 'components/container_painel';
import { ROUTES } from 'routes/constants';
import BoxCuffaFormulario from 'components/cuffa/BoxCuffaFormulario';
import { useCuffaStore } from 'stores/cuffa/cuffa.store';

export const getTemProgresso = (collectionUuid?: string, dadosParciais?: any) => {
  return Boolean(collectionUuid ?? dadosParciais?.ultimaRota);
};

export const getContinuarPayload = (uuidFromChild: string | null | undefined, collectionUuid?: string | null | undefined) => {
  const uuid = uuidFromChild ?? collectionUuid;
  if (uuid) {
    return {
      uuid,
      situacao: 'Em andamento',
      route: ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_EDITAR.replace(':uuid', uuid),
    };
  }
  return {
    uuid: undefined,
    situacao: 'Novo',
    route: ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_INCLUIR,
  };
};

const GerenciarCuffaHome: React.FC = () => {
  const navigate = useNavigate();
  const { collectionUuid } = useCuffaStore();
  const [showFormulario, setShowFormulario] = useState(false);
  const [formKey, setFormKey] = useState(0);


  const {
    situacao,
    dadosParciais,
    setSituacao,
    limparDadosParciais
  } = useCuffaStore();

  const handleContinuarPreenchimento = (uuidFromChild?: string) => {
    const payload = getContinuarPayload(uuidFromChild, collectionUuid);
    setSituacao(payload.situacao as any);
    navigate(payload.route);
  };




  const handleNovoFormulario = () => {
    limparDadosParciais();
    setSituacao('Novo');
    navigate(ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_INCLUIR);
  };

  const handleEditar = () => {
    if (collectionUuid) {
      setSituacao('Em andamento');
      navigate(ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_EDITAR.replace(':uuid', collectionUuid));
    }
  };

  const handleVisualizar = () => {
    if (collectionUuid) {
      navigate(ROUTES.IDENTIFICACAO_FAMILIAR_CUFFA_VISUALIZAR.replace(':uuid', collectionUuid));
    }
  };


  // useEffect(() => {
  //     const permissionName = user?.permission?.name;
  //     const isAdmin = Permissions.includes(permissionName as UserPermissionEnum);
  //     if (isAdmin) {
  //         navigate(ROUTES.LISTAR_CUFFA);
  //     }
  // }, [user]);

  const handleListarColetas = () => {
    navigate(ROUTES.LISTAR_CUFFA);
  };

  const handleIniciarFormulario = () => {
    setShowFormulario(true);
  };

  const handleVoltar = () => {
    limparDadosParciais();
    setSituacao('Novo');
    setFormKey(prev => prev + 1);
    setShowFormulario(false);
  };

  return (
    <ContainerPainel pagina="Gerenciar Coleta CUFFA" showBackButton={true}>
      <Box
        sx={{
          paddingTop: 8,
          backgroundColor: '#f9fafb',
          minHeight: 'auto',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
          Secretaria de Estado de Agricultura Familiar
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Cadastro Único de Famílias da Agricultura Familiar – CUFFA
        </Typography>

        {!showFormulario ? (
          /* Estado inicial: dois cards lado a lado */
          <Fade in={!showFormulario} timeout={600}>
            <Box sx={{ width: '100%' }}>
              <Grid container spacing={4} justifyContent="center" alignItems="stretch" sx={{ maxWidth: 900, margin: '0 auto', px: 2 }}>
                {/* Card 1: Iniciar nova coleta */}
                <Grid item xs={12} sm={6} md={5}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: 4,
                      textAlign: 'center',
                      borderRadius: '12px',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      minHeight: 280,
                      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: '50%',
                          backgroundColor: '#e8f5e9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto',
                          mb: 2
                        }}
                      >
                        <NoteAddOutlinedIcon sx={{ fontSize: 28, color: '#2e7d32' }} />
                      </Box>
                      <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Iniciar nova coleta CUFFA
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Utilize esta opção para iniciar o preenchimento de um novo formulário de coleta.
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      fullWidth
                      startIcon={<NoteAddOutlinedIcon />}
                      sx={{
                        backgroundColor: '#1565c0',
                        '&:hover': { backgroundColor: '#12539d' },
                        textTransform: 'none',
                        py: 1.5,
                        transition: 'all 0.3s ease'
                      }}
                      onClick={handleIniciarFormulario}
                    >
                      Iniciar novo formulário
                    </Button>
                  </Paper>
                </Grid>

                {/* Card 2: Visualizar Registros */}
                <Grid item xs={12} sm={6} md={5}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: 4,
                      textAlign: 'center',
                      borderRadius: '12px',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      minHeight: 280,
                      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: '50%',
                          backgroundColor: '#e3f2fd',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto',
                          mb: 2
                        }}
                      >
                        <FormatListBulletedIcon sx={{ fontSize: 28, color: '#1565c0' }} />
                      </Box>
                      <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Visualizar Registros
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Consulte e gerencie as coletas já realizadas no município.
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      fullWidth
                      startIcon={<FormatListBulletedIcon />}
                      sx={{
                        backgroundColor: '#1565c0',
                        '&:hover': { backgroundColor: '#12539d' },
                        textTransform: 'none',
                        py: 1.5,
                        transition: 'all 0.3s ease'
                      }}
                      onClick={handleListarColetas}
                    >
                      Listagem de registros
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Fade>
        ) : (
          /* Estado expandido: card de formulário centralizado */
          <Fade in={showFormulario} timeout={600}>
            <Box sx={{ maxWidth: 600, width: '100%', px: 2, transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)' }}>
              {/* Botão de voltar */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, animation: 'fadeInDown 0.5s ease' }}>
                <IconButton
                  onClick={handleVoltar}
                  sx={{
                    color: '#1565c0',
                    '&:hover': { backgroundColor: 'rgba(21, 101, 192, 0.08)' },
                    transition: 'all 0.3s ease'
                  }}
                  aria-label="Voltar"
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#1565c0',
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                    transition: 'all 0.3s ease'
                  }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Typography>
              </Box>

              {/* Card do formulário expandido */}
              <Box sx={{ animation: 'scaleUp 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' }}>
                <BoxCuffaFormulario
                  key={formKey}
                  nomeSecretaria="CUFFA"
                  situacao={situacao}
                  temProgresso={Boolean(collectionUuid ?? dadosParciais?.ultimaRota)}
                  onContinuar={handleContinuarPreenchimento}
                  onNovoFormulario={handleNovoFormulario}
                  onEditar={handleEditar}
                  onVisualizar={handleVisualizar}
                />
              </Box>

              <style>{`
                @keyframes fadeInDown {
                  from {
                    opacity: 0;
                    transform: translateY(-20px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }

                @keyframes scaleUp {
                  from {
                    opacity: 0;
                    transform: scale(0.95) translateY(10px);
                  }
                  to {
                    opacity: 1;
                    transform: scale(1) translateY(0);
                  }
                }
              `}</style>
            </Box>
          </Fade>
        )}
      </Box>
    </ContainerPainel>
  );
};

export default GerenciarCuffaHome;
